export default {
  adapters: {
    breadcrumbs: {
      editorial: {
        home: 'Home'
      },
      ugr: {
        home: 'Home'
      },
      recipes: {
        home: 'Recipes'
      }
    },
    cards: {
      userCollection: {
        // v4 plural
        savedItemDescription_one: 'item',
        savedItemDescription_few: 'items',
        savedItemDescription_many: 'items',
        savedItemDescription_other: 'items',
        // v3 plural
        savedItemDescription: 'item',
        savedItemDescription_plural: 'items',
        savedItemDescription_0: 'item',
        savedItemDescription_1: 'items',
        savedItemDescription_2: 'items'
      },
      userRecipe: {
        statusTextDraft: 'Draft recipe',
        statusApproved: 'Member recipe',
        statusPending: 'Awaiting approval',
        statusRejected: 'Recipe denied'
      }
    },
    iconAdapter: {
      // v4 plural
      formatTimeHours_one: '{{hours}} hr',
      formatTimeHours_few: '{{hours}} hrs',
      formatTimeHours_many: '{{hours}} hrs',
      formatTimeHours_other: '{{hours}} hrs',
      // v3 plural
      formatTimeHours: '{{hours}} hr',
      formatTimeHours_plural: '{{hours}} hrs',
      formatTimeHours_0: '{{hours}} hr',
      formatTimeHours_1: '{{hours}} hrs',
      formatTimeHours_2: '{{hours}} hrs',
      // v4 plural
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} mins',
      formatTimeMins_many: '{{minutes}} mins',
      formatTimeMins_other: '{{minutes}} mins',
      // v3 plural
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} mins',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} mins',
      formatTimeMins_2: '{{minutes}} mins'
    },
    pageSchema: {
      editorial: {
        recipe: {
          calories: '{{calories}} calories',
          carbContent: '{{carbs}} grams carbohydrates',
          fatContent: '{{fat}} grams fat',
          fibreContent: '{{fibre}} grams fiber',
          proteinContent: '{{protein}} grams protein',
          satFatContent: '{{saturates}} grams saturated fat',
          sodiumContent: '{{sodium}} milligram of sodium',
          sugarContent: '{{sugars}} grams sugar'
        }
      },
      ugr: {
        servesDefault: 'Serves'
      }
    },
    post: {
      ugr: {
        messageMember: 'Member recipe',
        messageOther: '{{status}} recipe',
        statuses: {
          draft: 'draft',
          approved: 'approved',
          rejected: 'rejected',
          pending: 'pending',
          published: 'published'
        }
      }
    },
    posts: {
      editorial: {
        list: {
          seeMoreText: 'See more'
        },
        liveBlog: {
          // v4 plural
          hour_one: 'hour ago',
          hour_few: 'hours ago',
          hour_many: 'hours ago',
          hour_other: 'hours ago',
          // v3 plural
          hour: 'hour ago',
          hour_plural: 'hours ago',
          hour_0: 'hour ago',
          hour_1: 'hours ago',
          hour_2: 'hours ago',
          // v4 plural
          lessThanHour_one: 'minute ago',
          lessThanHour_few: 'minutes ago',
          lessThanHour_many: 'minutes ago',
          lessThanHour_other: 'minutes ago',
          // v3 plural
          lessThanHour: 'minute ago',
          lessThanHour_plural: 'minutes ago',
          lessThanHour_0: 'minute ago',
          lessThanHour_1: 'minutes ago',
          lessThanHour_2: 'minutes ago',
          lessThanMinute: 'less than 1 minute ago',
          updatedMessageLive: 'LIVE updated',
          updatedMessageNotLive: 'Updated'
        }
      },
      postAdapter: {
        callout: 'This is a {{status}} {{entity}}',
        previewCallout: 'Preview',
        recommendedTitle: 'More like this',
        statuses: {
          draft: 'draft',
          approved: 'approved',
          rejected: 'rejected',
          pending: 'pending',
          preview: 'preview',
          published: 'published'
        },
        entities: {
          glossary: 'glossary',
          howTo: 'how to',
          editorialList: 'editorial list',
          plant: 'plant',
          post: 'post',
          recipe: 'recipe',
          review: 'review',
          'broadcast-show': 'broadcast show',
          venue: 'venue',
          page: 'page',
          'user-collection': 'user collection',
          blog: 'blog'
        }
      },
      recipeAdapter: {
        getPublicationMessage: 'Recipe from',
        nutritionHighInPrefix: 'high in',
        nutritionLabel: 'Nutrition',
        nutritionLowInPrefix: 'low in',
        planning: {
          'easily-doubled': 'Easily doubled',
          'easily-halved': 'Easily halved',
          freezable: 'Freezable'
        },
        recommendedAltTitle: 'Our Most Popular Alternative',
        servingsLabel: 'Serves'
      },
      userRecipeAdapter: {
        categoryDisplay: 'Recipes'
      }
    },
    sponsorTracking: {
      label: 'Advertising cooperation'
    },
    pageBlocks: {
      riddle: {
        errorMessage: 'There seems to be an issue with the quiz, please try again.'
      }
    }
  },
  controllers: {
    search: {
      modifyFilterOptions: {
        transform: {
          time: {
            // v4 plural
            hour_one: '{{hours}} hour',
            hour_few: '{{hours}} hours',
            hour_many: '{{hours}} hours',
            hour_other: '{{hours}} hours',
            // v3 plural
            hour: '{{hours}} hour',
            hour_plural: '{{hours}} hours',
            hour_0: '{{hours}} hour',
            hour_1: '{{hours}} hours',
            hour_2: '{{hours}} hours',
            // v4 plural
            minute_one: '{{minutes}} minute',
            minute_few: '{{minutes}} minutes',
            minute_many: '{{minutes}} minutes',
            minute_other: '{{minutes}} minutes',
            // v3 plural
            minute: '{{minutes}} minute',
            minute_plural: '{{minutes}} minutes',
            minute_0: '{{minutes}} minute',
            minute_1: '{{minutes}} minutes',
            minute_2: '{{minutes}} minutes',
            gte: '{{time}} or more',
            gt: 'Over {{time}}',
            lte: '{{time}} or less',
            lt: 'Under {{time}}'
          },
          calories: {
            gteOrGt: 'Over {{calories}} kcal',
            lteOrLt: 'Up to {{calories}} kcal'
          }
        }
      },
      siteSearchConfig: {
        facet: {
          label: {
            author: 'Author',
            calories: 'Calories',
            category: 'Categories',
            cuisine: 'Cuisine',
            diet: 'Diets',
            difficulty: 'Difficulty',
            mealType: 'Meal type',
            occasion: 'Occasion',
            ratings: 'Ratings',
            servings: 'Servings',
            totalTime: 'Total time'
          }
        },
        filter: {
          label: {
            recipe: 'Recipes',
            video: 'Video',
            guides: 'Guides',
            collection: 'Recipe collections',
            glossary: 'Glossary',
            review: 'Reviews'
          }
        },
        sortOptions: {
          label: {
            published: 'Latest added',
            quickest: 'Quickest',
            rating: 'Most popular',
            relevant: 'Most relevant'
          }
        }
      }
    }
  }
};